import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { useHabitContext } from "../../context/HabitContext";
import { FEATURES } from "../../utils/featureFlags";
import HabitYearDetail from "./HabitYearDetail";
import MonthlyReadOnlyView from "./MonthlyReadOnlyView";
import TasksYearView from "./TasksYearView";
import NotesListView from "./NotesListView";
import "./YearlyTracker.scss";

type StatsTab = "habits" | "tasks" | "notes";
type HabitsView = "yearly" | "monthly";

const VALID_TABS: StatsTab[] = ["habits", ...(FEATURES.STATS_TASKS_TAB ? ["tasks" as StatsTab] : []), "notes"];

const YearlyTracker: React.FC = () => {
  const { currentYear } = useHabitContext();
  const { formatMessage: t } = useIntl();
  const [searchParams] = useSearchParams();

  const tabParam = searchParams.get('tab') as StatsTab | null;
  const activeTab: StatsTab = tabParam && VALID_TABS.includes(tabParam) ? tabParam : 'habits';

  const [habitsView, setHabitsView] = useState<HabitsView>("yearly");

  const habitsSwitch = (
    <div className="yearly-view-switch">
      <button
        className={`yearly-view-switch__btn${habitsView === 'yearly' ? ' yearly-view-switch__btn--active' : ''}`}
        onClick={() => setHabitsView('yearly')}
      >
        {t({ id: 'stats.switch.yearly' })}
      </button>
      <button
        className={`yearly-view-switch__btn${habitsView === 'monthly' ? ' yearly-view-switch__btn--active' : ''}`}
        onClick={() => setHabitsView('monthly')}
      >
        {t({ id: 'stats.switch.monthly' })}
      </button>
    </div>
  );

  return (
    <div className="yearly-page">
      <div className="yearly-statistics-view">
        {activeTab === "habits" && habitsView === "yearly" && (
          <div className="yearly-habits-view">
            <HabitYearDetail year={currentYear} headerActions={habitsSwitch} />
          </div>
        )}

        {activeTab === "habits" && habitsView === "monthly" && (
          <div className="yearly-monthly-view">
            <MonthlyReadOnlyView headerActions={habitsSwitch} />
          </div>
        )}

        {FEATURES.STATS_TASKS_TAB && activeTab === "tasks" && (
          <div className="yearly-tasks-view">
            <TasksYearView />
          </div>
        )}

        {activeTab === "notes" && (
          <div className="yearly-notes-view">
            <NotesListView />
          </div>
        )}
      </div>
    </div>
  );
};

export default YearlyTracker;
